import React, { Component } from 'react'
import { Card, Table } from 'antd';
import { TenantService } from 'connection/TenantService';
import { mTLSResponse } from 'models/response/mTLSResponse';
import { activeMtlsCertificate, getMtlsDetails } from 'services/CeberusApiService';
import { TableAction } from 'components/TableAction';
import { SearchMtlsCertificatesRequest } from 'models/request/SearchMtlsCertificatesRequest';
import { SearchOrganizationResponse } from 'models/response/SearchOrganizationResponse';
import { PushNotification } from 'utils/PushNotification';

const { Column } = Table;

export class OrganizationMTLS extends Component<SearchOrganizationResponse> {
  state = {
    isLoading: false,
    mtlsDetails: new Array<mTLSResponse>()
  }

  async componentDidMount() {
    this.loadPage();
  }

  loadPage = async () => {
    try {
      const tenantSelected = TenantService.getSelectedTenant();
      this.setState({ tenantSelected, isLoading: true });

      if (!this.props.Id) {
        return;
      }

      const request = new SearchMtlsCertificatesRequest();
      request.OrganizationId = this.props.Id;
      request.ClusterName = this.props.ClusterName;

      const mtlsDetails = await getMtlsDetails(request);

      this.setState({ mtlsDetails });

    } catch (error) {
      PushNotification.httpError(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  handleOnActiveConfig = async ({ certificate_id }) : Promise<void> => {
    try {
      const request = new SearchMtlsCertificatesRequest();
      request.CertificateId = certificate_id;
      await activeMtlsCertificate(request);
      this.loadPage();
      PushNotification.success('mTLS activated successfully');
    } catch (error) {
      PushNotification.httpError(error);
    }
  }

  render() {

    const cardTitle = `Total of mTLS certificates on ${this.props.Name}: ${this.state.mtlsDetails.length}`;

    return (

      <div className='mt5 w-100'>
        <Card title={cardTitle} className='mb3' loading={this.state.isLoading}>
          <Table dataSource={this.state.mtlsDetails} rowKey="certificate_id">
            <Column
              title="Description"
              dataIndex="description"
              key="description"
            />
            <Column
              title="Expiration Date"
              dataIndex="expiration_date"
              key="expirationDate"
            />
            <Column
              title="Status"
              dataIndex="status"
              key="status"
              render={(status: string) => {
                return status === 'Valid' ? 'Active' : 'Inactive';
              }}
            />
            <Column title="Allowed Actions"
              render={(_, record: any) => (
                <TableAction
                  onActive={record.status !== 'Valid' ? () => this.handleOnActiveConfig(record) : undefined}
                  isActive={record.status === 'Valid'}
                  activeText="Activate"
                />
              )}/>
          </Table>
        </Card>
      </div>
    )
  }
}
